import { ModalTitleProps } from '../types'

export const isHeaderObject = (title: any): title is ModalTitleProps => {
  if (!title || typeof title === 'string') return false
  return 'header' in title
}
